import Service from '../Service'
import {http} from '../config'

export default class AvaliacaoModeloService extends Service{
    constructor(){
        super('AvaliacaoModelo');
    }

    Resumo(){
        return http.get(`${this.getNomeControle()}/Resumo`);
    }
}
